<template>
    <div class="share">
        <div class="body">
            <div>
                <div>我正在参加</div>
                <div>【{{detail.title}}】</div>
            </div>
            <div>
                <div>邀请你加入我的队伍</div>

                <div class="button" @click="join">加入队伍</div>
                <div class="button boder" @click="goback">查看活动</div>
            </div>
        </div>

        <div class="tips">
            <div>.加入该队伍，参与活动，即可为自己和好友提供步数加速</div>
            <div>.同一场活动只能加入一个队伍</div>
            <div>.队伍一旦加入不可退出</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            detail: {}
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.$api.activity.taskList({activity_id:this.$route.params.activity_id}).then(res=>{
                this.detail = res.data
            }).then(res=>{
                this.$api.user.upsteps({acid:this.$route.params.activity_id})
            })
        },
        join() {
            let that = this
            this.$dialog.confirm({
                title: '确认',
                message: '加入队伍？',
            })
            .then(() => {
                // on confirm
                that.$api.user.upstepsgroup({acid:that.$route.params.activity_id,groupid:that.$route.params.groupid}).then(res=>{
                    if(res.status == 200)
                        that.$toast('加入成功');
                })
            })
            .catch(() => {
                // on cancel
            });
        },
        goback() {
            this.$router.push({name:'xhdetail23',params:{activity_id:this.$route.params.activity_id,acid:this.$route.params.acid}})
        }
    }
}
</script>
<style lang="less">
    @import "index.less";
</style>